<template>
    <div class="item" @click="onPressNav('goodsDetail', {id: item.id})">
        <div class="pic-wrap goods-pic-wrap pos-r">
            <img :src="item.image" class="pic-img pos-a" />
        </div>
        <div>
            <p class="title">{{item.name}}</p>
            <div>
                <p class="price">￥<span>{{item.price}}</span></p>
                <span class="sale">已售{{item.sales_count || 0}}</span>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "goodsItem",
    props:['item'],
    data() {
        return {
            
        };
    },
    methods: {
        // 点击跳转
        onPressNav(router, query={}) {
            this.$router.push({path: '/'+router, query: query})
        },
    },
    created() {
        
    },
};
</script>
<style lang="less" scoped>
.item {
    overflow: hidden;
    margin-top: 1.5rem;
    border-radius: 3px;
    background: #ffffff;
    border-radius: 1rem;
    background: #ffffff;
    width: calc(50% - 0.8rem);
    box-shadow: 0px 0px 5px 0px rgba(51,51,51,0.10); 

    .goods-pic-wrap {
        padding: 45% 0;
        overflow: hidden;
        background: #bcbcbc;

        img {
            top: 51%;
            left: 0;
            width: 100%;
            object-fit: cover;
            transform: translateY(-53%);
        }
    }

    > div {
        padding: 1rem 1rem;

        .title {
            margin: 3px 0;
            font-size: 13px;
            color: #333;
            font-weight: 500;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }

        > div {
            display: flex;
            align-items: center;

            .price {
                flex: 1;
                margin-left: -3px;
                font-size: 10px;
                color: #EB0000;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;

                span {
                    font-size: 14px;
                }
            }

            .sale {
                font-size: 11px;
                color: #999;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
        }
    }
}
</style>